import React from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useCartStore } from "~/stores/use-cart-store";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { RegisterButton } from "../ui/register-button";
import { ScrollArea } from "../ui/scroll-area";
import CartItemExtraForm from "./cart-item-extra-form";

export default function CartItemExtraDialog() {
  const { t } = useTranslation("common");

  const { extraDialogOpen, setExtraDialogOpen, selectedItem } = useCartStore();

  const handleDialog = (open: boolean) => {
    if (open === false) {
      setTimeout(() => {
        setExtraDialogOpen(false);
      }, 150);
    }
    setExtraDialogOpen(open);
  };

  return (
    <Dialog open={extraDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-4xl w-full">
        <DialogHeader>
          <DialogTitle>{t("CartItem.add_extra")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          {selectedItem && (
            <CartItemExtraForm
              item={selectedItem}
              onClose={() => handleDialog(false)}
            />
          )}
        </div>
        <DialogFooter>
          <RegisterButton
            form="cart-item-extra-form"
            type="submit"
            variant="success"
            className="w-full"
          >
            Apply Extra's
          </RegisterButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
